const Sentry = {
  nativeCrash: () => {
    console.log('Native crash');
  },
};

export default Sentry;
